<svg [attr.viewBox]="getViewBox()" [style.width]="data.widthPx + 10 | px" [style.height]="data.heightPx | px" preserveAspectRatio="none">
	<rect x="0" y="0" [attr.width]="data.widthPx / 4" [attr.height]="data.heightPx" [class]="data.invertColors ? 'high' : 'low'"></rect>
	<rect [attr.x]="0.25 * data.widthPx" y="0" [attr.width]="data.widthPx / 2" [attr.height]="data.heightPx" class="middle"></rect>
	<line [attr.x1]="0.5 * data.widthPx" [attr.x2]="0.5 * data.widthPx" [attr.y1]="0" [attr.y2]="data.heightPx"></line>
	<rect
		[attr.x]="0.75 * data.widthPx"
		y="0"
		[attr.width]="data.widthPx / 4"
		[attr.height]="data.heightPx"
		[class]="data.invertColors ? 'low' : 'high'"
	></rect>
	@if (getCx() !== null) {
		<circle [attr.cx]="getCx()" [attr.cy]="data.heightPx / 2" r="4"></circle>
	}
</svg>
